import { Component, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BasketService } from '../_services/basket.service';
import { PricelistService } from '../_services/pricelist.service';
import { ToastrService } from 'ngx-toastr';
import { Promotion } from '../_models/promotion';
import { PriceListLine } from '../_models/pricelistline';
import { BasketAdd } from '../_models/basketadd';
import { Router } from '@angular/router';
import { Dialog, DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'app-promotion',
    templateUrl: './promotion.component.html',
    styleUrls: ['./promotion.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PromotionComponent implements OnInit {
  promotionForm: FormGroup;
  promotions: Promotion[];
  errorMessage: string;

  pictureDialogRef: DialogRef<unknown, any>;
  pictureUrl1: string;
  pictureUrl2: string;
  pictureUrl3: string;
  pictureStatus1: string;
  pictureStatus2: string;
  pictureStatus3: string;
  pictureUrlActive: string;
  picturePartNumber: string;

  constructor(private pricelistService: PricelistService, private fb: FormBuilder, 
    private basketService: BasketService, private toastr: ToastrService, private router: Router, private dialog: Dialog) { }

  ngOnInit(): void {
    this.initializeForm();

    this.load();
  }

  initializeForm(){
    this.promotionForm = this.fb.group({
      'promo': this.fb.array([]),
    })
  }

  load()  {
    this.pricelistService.getPromotions().subscribe({
      next: lines => {
        this.promotions = lines;
        var teller = 0;
        this.promotions.forEach(promotion => {
          
          this.addPromotion(promotion.promotionHeader.prijslijstnummer);
          
          promotion.promotionLines.forEach(lijn => {
            this.addPromotionlijn(teller, lijn);
          })
          //console.log(this.promotionForm);
          teller = teller + 1;
        })
      },
      error: err => this.errorMessage = err
    });
  }  

  promoArray(): FormArray {
    return this.promotionForm.get("promo") as FormArray
  }

  addPromotion(prijslijstnr: string) {
    this.promoArray().push(this.newPromotion(prijslijstnr))
  }

  newPromotion(prijslijstnr: string) : FormGroup {
    return this.fb.group({
      prijslijstNummer: prijslijstnr,
      lijnen: this.fb.array([]),
    });
  }

  prijslijstLijnen(lijnIndex:number) : FormArray {
    return this.promoArray().at(lijnIndex).get("lijnen") as FormArray
  }

  addPromotionlijn(empIndex:number, pricelistline:PriceListLine) {
    this.prijslijstLijnen(empIndex).push(this.newPromotionLijn(pricelistline));
  }

  newPromotionLijn(pricelistline:PriceListLine): FormGroup {
    return this.fb.group({
      pricelistline: pricelistline,
      qty: '',
    })
  }

  onAddToBasket()
  {
    var lijnenToegevoegd = 0;
    this.promoArray().controls.forEach(promotieheader  => {   

      promotieheader.value.lijnen.forEach(lijn => {
        if (lijn.qty > 0)
        {
          //console.log(lijn);
          lijnenToegevoegd = lijnenToegevoegd + 1;

          let basketadd : BasketAdd = {
            xref : lijn.pricelistline.xref,
            aantal : lijn.qty,
            prijs : lijn.pricelistline.prijs,
            merk : lijn.pricelistline.merk,
            promotionId : 0
          }
          //console.log(basketadd);
          this.basketService.Add(basketadd);
          lijn.qty = "";
        }
        
      })
    })

    if (lijnenToegevoegd === 0)
    {
      this.toastr.warning("Nothing added to order.");
    }
    else
    {
      this.toastr.success(lijnenToegevoegd + " line(s) added to order.");
      //this.router.navigateByUrl('/order');
      setTimeout(() => 
      {
        this.router.navigateByUrl('/order');
      },
      500);
    }
  }

  openPicture(template: TemplateRef<unknown>, pictureArticle1: string,pictureArticle2: string, pictureArticle3: string, picturePartnumber: string) 
  {
    this.pictureUrl1 = pictureArticle1;
    this.pictureUrl2 = pictureArticle2;
    this.pictureUrl3 = pictureArticle3;
    this.pictureUrlActive = pictureArticle1;
    this.pictureStatus1 = "pictureactive";
    this.pictureStatus2 = "pictureinactive";
    this.pictureStatus3 = "pictureinactive";
    this.picturePartNumber = picturePartnumber;
    // you can pass additional params, choose the size and much more
    this.pictureDialogRef = this.dialog.open(template,{
      height: '800px',
      width: '1000px',

      panelClass: 'mydialog',
    });
 }

 changeActivePicture(pictureNumber: number)
 {
    if (pictureNumber == 1)
    {
      this.pictureUrlActive = this.pictureUrl1;
      this.pictureStatus1 = "pictureactive";
      this.pictureStatus2 = "pictureinactive";
      this.pictureStatus3 = "pictureinactive";
    }
    if (pictureNumber == 2)
    {
      this.pictureUrlActive = this.pictureUrl2;
      this.pictureStatus1 = "pictureinactive";
      this.pictureStatus2 = "pictureactive";
      this.pictureStatus3 = "pictureinactive";
    }
    if (pictureNumber == 3)
    {
      this.pictureUrlActive = this.pictureUrl3;
      this.pictureStatus1 = "pictureinactive";
      this.pictureStatus2 = "pictureinactive";
      this.pictureStatus3 = "pictureactive";
    }
 }

 addRegel(index: number, index2: number){

  let promotion = (<FormArray>this.promotionForm.get('promo')).at(index).value;
  //console.log(promotion);

  let orderregel = promotion.lijnen[index2];

  if (orderregel.qty > 0)
  {
    let basketadd : BasketAdd = {
      xref : orderregel.pricelistline.xref,
      aantal : orderregel.qty,
      prijs : orderregel.pricelistline.prijs,
      merk : orderregel.pricelistline.merk,
      promotionId : 0
    }
  
    //console.log(basketadd);
    this.basketService.Add(basketadd);
    this.toastr.success(orderregel.pricelistline.xref + " added to order.");
  }

  orderregel.qty = '';
  (<FormArray>this.promotionForm.get('promo')).at(index).patchValue(promotion);
  
  //console.log(orderregel);
}

}
